export default __webpack_public_path__ + "1239865cc34ab2b76bf77c635243b4bc.png";